import constants from '@constants';
import utils from '@utils';

// 通知バーの成功・失敗メッセージ

export const getNotifyMessage = (
  type: 'success' | 'error',
  method: 'create' | 'update' | 'delete',
  resource: 'user' | 'admin' | 'me' | 'superAdmin'
) => {
  const getMethod = () => {
    switch (method) {
      case 'create':
        return '登録';
      case 'update':
        return '更新';
      case 'delete':
        return '削除';
    }
  };

  if (type === 'success') {
    return `${getResource(resource)}の${getMethod()}に成功しました`;
  }

  if (type === 'error') {
    return `${getResource(resource)}の${getMethod()}に失敗しました`;
  }
};

// 取得時のエラーメッセージ

export const getErrorMessage = (
  message: string,
  resource: 'user' | 'admin' | 'superAdmin'
) => {
  const targetResource = getResource(resource);

  switch (message) {
    case 'Request failed with status code 400':
      return `存在しない${targetResource}です`;
    case 'not admin user':
      return `管理者権限を持ったユーザーではありません`;
    default:
      return constants.ERRORS.UNKNWON;
  }
};

const getResource = (resource: 'user' | 'admin' | 'me' | 'superAdmin') => {
  switch (resource) {
    case 'user':
      return '一般ユーザー';
    case 'admin':
      return '管理者';
    case 'me':
      return 'プロフィール';
    case 'superAdmin':
      return '特権管理者';
  }
};

// 生年月日用のドロップダウン用配列を取得する
export const getBirthSelections = (
  type: 'years' | 'months' | 'days',
  options: {currentYear?: number; currentMonth?: number} = {}
) => {
  const selections: {key: any; text: string; value: any}[] = [];

  // 空白用の行を作成する
  selections.push({
    key: 0,
    value: null,
    text: '',
  });

  if (type === 'years') {
    // 現在の年を取得
    const currentYear = utils.date.getNow('YYYY');

    for (let i = 0; i < constants.USERS.SELECT_BIRTH_YEARS; i++) {
      const target = Number(Number(currentYear) - i);
      const selection = {
        key: i + 1,
        text: `${target}`,
        value: target,
      };

      selections.push(selection);
    }
  } else if (type === 'months') {
    // 月の数だけ配列にプッシュする
    for (let i = 0; i < constants.USERS.SELECT_BIRTH_MONTHS; i++) {
      const selection = {
        key: i + 1,
        text: `${i + 1}`,
        value: i + 1,
      };

      selections.push(selection);
    }
  } else if (type === 'days') {
    // 初期値は31日で計算
    let days = constants.USERS.SELECT_BIRTH_DAYS;

    // 現在の年と日付が渡されている場合のみ、その年月に合わせた日数を取得する
    if (options.currentYear && options.currentMonth) {
      days = utils.date.getDaysInMonth({
        year: options.currentYear,
        month: options.currentMonth,
      });
    }

    // 日数の数だけ配列にプッシュする
    for (let i = 0; i < days; i++) {
      const selection = {
        key: i + 1,
        text: `${i + 1}`,
        value: i + 1,
      };

      selections.push(selection);
    }
  }

  return selections;
};

// 年月日を結合した日付を返す
export const getBirthDate = (year: number, month: number, day: number) => {
  if (year && month && day) {
    return `${year}/${month}/${day}`;
  } else {
    return '';
  }
};

// 引数で渡された対象の日付を返す
export const getBirthValue = (
  unit: 'year' | 'month' | 'day',
  date: string = ''
) => {
  let format = '';

  if (!date) {
    return '';
  }

  // 対象によってフォーマットを変更する
  switch (unit) {
    case 'year':
      format = 'YYYY';
      break;
    case 'month':
      format = 'M';
      break;
    case 'day':
      format = 'D';
      break;
    default:
      break;
  }

  const target = Number(utils.date.format(date, format, false, false));

  if (target > 0) {
    return target;
  } else {
    return null;
  }
};

// エラーが発生している年月日のフォーム名を取得する
export const getBirthError = (
  errors: {[key: string]: any},
  touched: {[key: string]: any},
  keys: {
    year: string;
    month: string;
    day: string;
  }
) => {
  if (touched[keys.year] && errors[keys.year]) {
    return errors[keys.year];
  }

  if (touched[keys.month] && errors[keys.month]) {
    return errors[keys.month];
  }

  if (touched[keys.day] && errors[keys.day]) {
    return errors[keys.day];
  }

  return '';
};

export const getDisabled = (
  me: MeStore,
  user: UsersStore['detail'],
  email?: boolean
) => {
  // メールアドレスは全ユーザー変更不可
  if (email) {
    return true;
  }

  // 編集したいユーザーが特権管理者以外の時
  if (user.authLevel !== constants.AUTHORITIES.SUPER_ADMIN) {
    return false;
  }

  // 編集したいユーザーが特権管理者の時 (管理者には編集させない)
  if (
    user.authLevel === constants.AUTHORITIES.SUPER_ADMIN &&
    me.authLevel === constants.AUTHORITIES.SUPER_ADMIN
  ) {
    return false;
  } else {
    return true;
  }
};
